import { render, staticRenderFns } from "./Streaming.vue?vue&type=template&id=812c5488"
import script from "./Streaming.vue?vue&type=script&lang=js"
export * from "./Streaming.vue?vue&type=script&lang=js"
import style0 from "./Streaming.vue?vue&type=style&index=0&id=812c5488&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports